const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const DAY = 86400000;

const parse = (iso) => new Date(`${iso}T00:00:00Z`);
const short = (d) => `${MONTHS[d.getUTCMonth()]} ${d.getUTCDate()}`;
const mondayOf = (t) => t - ((new Date(t).getUTCDay() + 6) % 7) * DAY;

// Monday to Sunday weeks covering start..end, empty weeks kept as zero
export const toWeeks = (rows = [], start, end) => {
  if (!rows.length) return [];
  const isos = rows.map((r) => r.iso).sort();
  const lo = parse(start || isos[0]).getTime();
  const hi = parse(end || isos[isos.length - 1]).getTime();
  const totals = new Map();
  for (const r of rows) {
    const k = mondayOf(parse(r.iso).getTime());
    const w = totals.get(k) || { impressions: 0, clicks: 0 };
    w.impressions += r.impressions || 0;
    w.clicks += r.clicks || 0;
    totals.set(k, w);
  }
  const out = [];
  for (let k = mondayOf(lo); k <= hi; k += 7 * DAY) {
    const from = new Date(Math.max(k, lo)), to = new Date(Math.min(k + 6 * DAY, hi));
    const days = Math.round((to - from) / DAY) + 1;
    const range = from.getUTCMonth() === to.getUTCMonth() ? `${short(from)} to ${to.getUTCDate()}` : `${short(from)} to ${short(to)}`;
    const w = totals.get(k) || { impressions: 0, clicks: 0 };
    out.push({
      iso: from.toISOString().slice(0, 10),
      date: short(from),
      tipLabel: `${range}${days < 7 ? ` (${days} days)` : ""}`,
      bestLabel: `the week of ${range}`,
      impressions: Math.round(w.impressions),
      clicks: Math.round(w.clicks),
    });
  }
  return out;
};
